const Address = require('./Address');
const Child = require('./Child');

const empty = (str) => {
  return (!str || str.length === 0);
};
class Parent {
  constructor() {
    this.init();
  }

  init() {
    this.parent_id = undefined;
    this.first_name = '';
    this.last_name = '';
    this.email = undefined;
    this.phone_number = undefined;
    this.work_phone_number = undefined;
    this.cell_phone_number = undefined;
    this.can_text = undefined;
    this.primary_phone = undefined;
    this.pid_spouse = undefined;
    this.company = undefined;
    this.children = [];
    this.navigators = [];
    this.address = new Address();
    this.subsidies = undefined;
  }

  copy() {
    const cp = new Parent();

    cp.parent_id = this.parent_id;
    cp.first_name = this.first_name;
    cp.last_name = this.last_name;
    cp.email = this.email;
    cp.phone_number = this.phone_number;
    cp.work_phone_number = this.work_phone_number;
    cp.cell_phone_number = this.cell_phone_number;
    cp.can_text = this.can_text;
    cp.primary_phone = this.primary_phone;
    cp.pid_spouse = this.pid_spouse;
    cp.company = this.company;
    cp.address = this.address;
    cp.subsidies = this.subsidies ? [].concat(this.subsidies) : undefined;

    cp.children = [];
    this.children.forEach((c) => {
      cp.children.push(c);
    });
    cp.navigators = [];
    this.navigators.forEach((n) => {
      cp.navigators.push(n);
    });
    return cp;
  }

  isEmpty() {
    return (this.address.isEmpty() && empty(this.first_name) && empty(this.last_name) && empty(this.email)
      && empty(this.company) && empty(this.phone_number) && (this.navigators.length === 0));
  }

  buildFromJSON(obj) {
    this.init();
    if (obj) {
      this.parent_id = obj.parent_id ? obj.parent_id.toString() : undefined;
      this.first_name = obj.first_name ? obj.first_name : '';
      this.last_name = obj.last_name ? obj.last_name : '';
      this.email = obj.email ? obj.email : undefined;
      this.phone_number = obj.phone_number ? obj.phone_number : undefined;
      this.work_phone_number = obj.work_phone_number ? obj.work_phone_number : undefined;
      this.cell_phone_number = obj.cell_phone_number ? obj.cell_phone_number : undefined;
      this.can_text = (obj.can_text !== undefined) && (obj.can_text !== null) ? obj.can_text : undefined;
      this.primary_phone = obj.primary_phone ? obj.primary_phone : undefined;
      this.pid_spouse = obj.pid_spouse ? obj.pid_spouse.toString() : undefined;
      this.company = obj.company ? obj.company : undefined;
      this.address.buildFromJSON(obj.address ? obj.address : {});
      this.subsidies = obj.subsidies ? [].concat(obj.subsidies) : undefined;

      this.children = [];
      if (obj.children && Array.isArray(obj.children)) {
        obj.children.forEach((c) => {
          const child = new Child();
          child.buildFromJSON(c);
          this.children.push(child);
        });
      }
      this.navigators = [];
      if (obj.navigators && Array.isArray(obj.navigators)) {
        obj.navigators.forEach((n) => {
          this.navigators.push(n.toString());
        });
      }
    }
  }

  toString() {
    let result = this.first_name;
    const address = this.address.toString();

    if (this.last_name.length) {
      result = (result.length) ? `${result} ${this.last_name}` : this.last_name;
    }
    if (!result.length) {
      result = 'No Name';
    }
    if (this.email) {
      result = `${result}: (${this.email})`;
    }
    if (this.phone_number) {
      result = (this.email) ? `${result} ${this.phone_number}` : `${result}: ${this.phone_number}`;
    }
    if (address.length) {
      result = (result.length) ? `${result}: ${address}` : address;
    }

    return result;
  }

  getId() {
    return this.parent_id;
  }

  setId(parent_id) {
    this.parent_id = parent_id ? parent_id.toString() : undefined;
  }

  getName() {
    let result = this.first_name;

    if (this.last_name.length) {
      result = (result.length) ? `${result} ${this.last_name}` : this.last_name;
    }
    if (!result.length) {
      result = 'No Name';
    }

    return result;
  }

  getFirstName() {
    return this.first_name;
  }

  setFirstName(first_name) {
    this.first_name = first_name;
  }

  getLastName() {
    return this.last_name;
  }

  setLastName(last_name) {
    this.last_name = last_name;
  }

  getCompany() {
    return this.company;
  }

  setCompany(company) {
    this.company = company;
  }

  getEmail() {
    return this.email;
  }

  setEmail(email) {
    this.email = email;
  }

  getPhoneNumber() {
    return this.phone_number;
  }

  setPhoneNumber(phone_number) {
    this.phone_number = phone_number;
  }

  getWorkPhoneNumber() {
    return this.work_phone_number;
  }

  setWorkPhoneNumber(work_phone_number) {
    this.work_phone_number = work_phone_number;
  }

  getCellPhoneNumber() {
    return this.cell_phone_number;
  }

  setCellPhoneNumber(cell_phone_number) {
    this.cell_phone_number = cell_phone_number;
  }
  
  getCanText() {
    return this.can_text;
  }

  setCanText(can_text) {
    this.can_text = can_text;
  }

  getPrimaryPhone() {
    return this.primary_phone;
  }

  setPrimaryPhone(primary_phone) {
    this.primary_phone = primary_phone;
  }

  getSpouseId() {
    return this.pid_spouse;
  }

  setSpouseId(pid_spouse) {
    this.pid_spouse = pid_spouse ? pid_spouse.toString() : undefined;
  }

  getChildren() {
    return this.children;
  }

  setChildren(children) {
    this.children = [];

    if (children && Array.isArray(children)) {
      children.forEach((c) => {
        this.children.push(c.copy());
      });
    }
  }

  getNavigators() {
    return this.navigators;
  }

  setNavigators(navigators) {
    this.navigators = [];

    if (navigators && Array.isArray(navigators)) {
      navigators.forEach((n) => {
        this.navigators.push(n.toString());
      });
    }
  }
  
  getAddress() {
    return this.address;
  }

  setAddress(address) {
    this.address = address;
  }

  getSubsidies() {
    return this.subsidies || [];
  }

  setSubsidies(subsidies) {
    this.subsidies = subsidies ? [].concat(subsidies) : undefined;
  }
}

module.exports = Parent;
